import { useContext } from "react";
import { BusinessAuthContext } from "./BusinessAuthContext";

export const useBusinessAuthContext = () => {
    const context = useContext(BusinessAuthContext);
    if(!context){
        throw Error('useBusinessAuthContext must be used inside business pages');
    }
    return context;
}